import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { DEFAULT_PAYMENT_THEME, type PaymentTheme } from "@/constants/theme";

export interface ThemeState {
  theme: PaymentTheme;
}

const initialState: ThemeState = {
  theme: { ...DEFAULT_PAYMENT_THEME },
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<Partial<PaymentTheme>>) => {
      state.theme = { ...state.theme, ...action.payload };
    },
    resetTheme: () => ({ theme: { ...DEFAULT_PAYMENT_THEME } }),
  },
});

export const { setTheme, resetTheme } = themeSlice.actions;
export default themeSlice.reducer;

export const selectPaymentTheme = (state: { theme: ThemeState }) => state.theme.theme;
